import { createContext } from 'react';

export const itemExpireContext = createContext<{
  displayTime: string;
  time: number;
  alwaysShowTime: boolean;
}>({
  displayTime: '',
  time: Infinity,
  alwaysShowTime: false,
});

export function useItemExpireContext() {
  return useContext(itemExpireContext);
}
